import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ContainerFilledSvg from "@ant-design/icons-svg/es/asn/ContainerFilled";
import AntdIcon from "../components/AntdIcon";
var ContainerFilled = function ContainerFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ContainerFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ContainerFilled.displayName = 'ContainerFilled';
}
export default /*#__PURE__*/React.forwardRef(ContainerFilled);